export function findClosestValueIndex(values, currentValue) {
  const result = values.reduce((acc, value, index) => {
    const distance = Math.abs(currentValue - value);
    if (acc === null || distance < acc.distance || distance === acc.distance) {
      return {
        distance,
        index
      };
    }
    return acc;
  }, null);
  if (result) {
    return result.index;
  }
  return 0;
}